/**
 * Formularwert einer Deadline und die Umrechnung von/zu den gespeicherten
 * Feldern - getrennt von `DeadlineField`, damit die Komponentendatei nur
 * Komponenten exportiert.
 */
import type { LocalDate } from '@/domain/types';

export interface DeadlineValue {
  date: LocalDate | '';
  time: string;
}

/** Gespeicherte Felder -> Formularwert. */
export function toDeadlineValue(date?: LocalDate, time?: string): DeadlineValue {
  return { date: date ?? '', time: time ?? '' };
}

/** Formularwert -> Felder zum Speichern; leer heisst entfernen (`undefined`). */
export function fromDeadlineValue(v: DeadlineValue): { date?: LocalDate; time?: string } {
  if (!v.date) return { date: undefined, time: undefined };
  return { date: v.date, time: v.time || undefined };
}
